<template>
	<div v-loading="loading" element-loading-text="下载中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row>
			<el-card>
				<el-row :gutter="15">
					<el-col>
						<el-form ref="formSearch" :model="searchData" label-width="80px" size="mini" :inline="true">
							<el-form-item prop="area">
								<el-select v-model="searchData.area" filterable multiple collapse-tags placeholder="省份">
									<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="tender_method">
								<el-select v-model="searchData.tender_method" filterable multiple collapse-tags
									placeholder="招标方式">
									<el-option v-for="item in bidMethodOptions" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="keywords"><el-input v-model="searchData.keywords"
									placeholder="医院/招标产品/中标产品" clearable maxlength="45" />
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="submitFormSearchData()">搜索</el-button>
								<el-button @click="resetSearchForm('formSearch')">重置</el-button>
								<el-divider direction="vertical"></el-divider>
								<el-button type="success" @click="exportData(searchData, '医院招投标数据')">导出</el-button>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>

				<el-table :data="tableData" style="width: 100%; margin: 10px 0;" stripe>
					<!-- 展开行 -->
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="expand-wrapper">
								<el-tabs tab-position="top">

									<!-- ================= 基本信息 ================= -->
									<el-tab-pane label="基本信息">
										<el-card shadow="never" class="card">
											<el-descriptions :column="2" border size="medium">
												<el-descriptions-item label="所属科室">
													{{ scope.row.tender_dept }}
												</el-descriptions-item>
												<el-descriptions-item label="开始时间">
													{{ formatDate(scope.row.start_date) }}
												</el-descriptions-item>
												<el-descriptions-item label="招标方式">
													<el-tag type="danger">{{ scope.row.tender_method }}</el-tag>
												</el-descriptions-item>
												<el-descriptions-item label="结束时间">
													{{ formatDate(scope.row.end_date) }}
												</el-descriptions-item>
												<el-descriptions-item label="招标背景">
													{{ scope.row.tender_background }}
												</el-descriptions-item>
											</el-descriptions>
										</el-card>
									</el-tab-pane>

									<el-tab-pane label="影响因子">
										<el-card shadow="never" class="card">
											<el-descriptions :column="2" border size="medium">

												<el-descriptions-item label="价格/技术/商务占比">
													{{ scope.row.score_ratio }}
												</el-descriptions-item>

												<el-descriptions-item label="关键决策者">
													{{ scope.row.key_decision_makers }}
												</el-descriptions-item>

												<el-descriptions-item label="客情关系状态">
													{{ scope.row.client_relationship_status }}
												</el-descriptions-item>

												<el-descriptions-item label="是否介入参数引导">
													<el-tag
														:type="scope.row.has_parameter_guidance ? 'success' : 'danger'">
														{{ scope.row.has_parameter_guidance ? '是' : '否' }}
													</el-tag>
												</el-descriptions-item>

												<el-descriptions-item label="主要竞争对手">
													<el-tag v-for="item in splitList(scope.row.main_competitors)"
														:key="item" style="margin-right:4px" size="mini">
														{{ item }}
													</el-tag>
												</el-descriptions-item>
											</el-descriptions>
										</el-card>
									</el-tab-pane>

									<!-- ================= 招标产品 ================= -->
									<el-tab-pane label="招标产品">
										<el-table :data="scope.row.tender_products" border stripe size="large"
											max-height="320">
											<el-table-column label="品名" prop="tender_product" show-overflow-tooltip />
											<el-table-column label="规格" prop="tender_spec" />
											<el-table-column label="价格(元)" prop="tender_price" align="right" />

											<el-table-column label="更新时间">
												<template slot-scope="scope">
													{{ formatDate(scope.row.update_date) }}
												</template>
											</el-table-column>

										</el-table>
									</el-tab-pane>

									<!-- ================= 投标信息 ================= -->
									<el-tab-pane label="投标及中标信息">
										<el-table :data="scope.row.tender_bids" border stripe size="large"
											max-height="320">
											<el-table-column label="投标公司" prop="bid_company" />
											<el-table-column label="品牌" prop="bid_brand" />
											<el-table-column label="品名" prop="bid_product_name" show-overflow-tooltip />
											<el-table-column label="规格" prop="bid_spec" />
											<el-table-column label="配比" prop="bid_dilution" />

											<el-table-column label="投标价格" prop="bid_price" align="right" />

											<el-table-column label="是否中标">
												<template slot-scope="scope">
													<el-tag :type="scope.row.is_win ? 'success' : 'warning'">
														{{ scope.row.is_win ? '中标' : '未中标' }}
													</el-tag>
												</template>
											</el-table-column>

											<el-table-column label="中标价格(元)" prop="win_price" align="right" />

											<el-table-column label="供货效期" prop="supply_expire" />

											<!-- <el-table-column label="备注" prop="remark" show-overflow-tooltip /> -->

											<el-table-column label="更新时间">
												<template slot-scope="scope">
													{{ formatDate(scope.row.update_date) }}
												</template>
											</el-table-column>


										</el-table>
									</el-tab-pane>

									<!-- ================= 复盘总结 ================= -->
									<el-tab-pane label="复盘总结">
										<el-card shadow="never">
											<el-descriptions :column="1" border size="medium">
												<el-descriptions-item label="中标/丢标核心原因">
													{{ scope.row.tender_result_core_reason }}
												</el-descriptions-item>
												<el-descriptions-item label="后续跟进动作">
													{{ scope.row.follow_up_actions }}
												</el-descriptions-item>
												<el-descriptions-item label="备注">
													{{ scope.row.tender_remark }}
												</el-descriptions-item>
											</el-descriptions>
										</el-card>
									</el-tab-pane>
								</el-tabs>

							</div>
						</template>
					</el-table-column>

					<!-- ================= 主表 ================= -->
					<el-table-column label="省份" prop="hospital_area" sortable />
					<el-table-column label="市/地区" prop="hospital_city" sortable />
					<el-table-column label="医院" prop="hospital_name" show-overflow-tooltip sortable min-width="150" />
					<el-table-column label="科室" prop="tender_dept" sortable/>
					<el-table-column label="招标背景" prop="tender_background" sortable/>
					<el-table-column label="招标方式" prop="tender_method" sortable />
					<el-table-column label="开始日期" prop="start_date" sortable />
					<el-table-column label="结束日期" prop="end_date" sortable />
					<el-table-column label="填报人" prop="tender_user__person_name" sortable />

					<el-table-column label="最后更新">
						<template slot-scope="scope">
							{{ formatDate(scope.row.update_date) }}
						</template>
					</el-table-column>

				</el-table>

				<!-- 分页 -->
				<el-row class="paginator hidden-sm-and-down">
					<el-pagination background :current-page.sync="currentPage" layout="total, sizes, prev, pager, next"
						:total="totalItems" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
						@current-change="handleCurrentChange" @size-change="handleSizeChange" />
				</el-row>

				<el-row class="paginator hidden-sm-and-up">
					<el-pagination background :current-page.sync="currentPage" layout="prev, pager, next"
						:total="totalItems" :page-size="pageSize" @current-change="handleCurrentChange"
						@size-change="handleSizeChange" prev-text="上一页" next-text="下一页" :pager-count="5" />
				</el-row>
			</el-card>
		</el-row>

		<el-row :gutter="10" style="margin-top: 10px;">
			<!-- <el-col :xs="24" :sm="24"> -->
			<el-col :span="24">
				<el-card>
					<el-tabs v-model="barChartActiveName">
						<el-tab-pane label="填报数据统计-按地区" name="bar_area">
							<div class="plate-card">
								<v-chart :options="bar_chart_area" autoresize></v-chart>
							</div>
						</el-tab-pane>
						<el-tab-pane label="填报数据统计-按用户" name="bar_user">
							<div class="plate-card"><v-chart :options="bar_chart_user" autoresize></v-chart>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
			<!-- </el-col> -->
		</el-row>
	</div>
</template>

<script>
	export default {
		inject: ['reload', 'logout'],
		data() {
			return {
				tableData: [],
				ifFullScreen: false,
				totalItems: 100,
				currentPage: 1,
				pageSize: 20,
				loading: false,
				formLabelWidth: '100px',

				searchData: {
					area: [],
					keywords: '',
					tender_method: '',
				},
				barChartActiveName: 'bar_area',
				prodTypeOptions: [],
				prodBrandOptions: [{
					value: 0,
					label: '竞品'
				}],
				provinceOptions: [{
						value: '北京',
						label: '北京'
					},
					{
						value: '天津',
						label: '天津'
					},
					{
						value: '上海',
						label: '上海'
					},
					{
						value: '重庆',
						label: '重庆'
					},
					{
						value: '河北',
						label: '河北'
					},
					{
						value: '山西',
						label: '山西'
					},
					{
						value: '辽宁',
						label: '辽宁'
					},
					{
						value: '吉林',
						label: '吉林'
					},
					{
						value: '黑龙江',
						label: '黑龙江'
					},
					{
						value: '江苏',
						label: '江苏'
					},
					{
						value: '浙江',
						label: '浙江'
					},
					{
						value: '安徽',
						label: '安徽'
					},
					{
						value: '福建',
						label: '福建'
					},
					{
						value: '江西',
						label: '江西'
					},
					{
						value: '山东',
						label: '山东'
					},
					{
						value: '河南',
						label: '河南'
					},
					{
						value: '湖北',
						label: '湖北'
					},
					{
						value: '湖南',
						label: '湖南'
					},
					{
						value: '广东',
						label: '广东'
					},
					{
						value: '甘肃',
						label: '甘肃'
					},
					{
						value: '四川',
						label: '四川'
					},
					{
						value: '贵州',
						label: '贵州'
					},
					{
						value: '海南',
						label: '海南'
					},
					{
						value: '云南',
						label: '云南'
					},
					{
						value: '青海',
						label: '青海'
					},
					{
						value: '陕西',
						label: '陕西'
					},
					{
						value: '广西',
						label: '广西'
					},
					{
						value: '西藏',
						label: '西藏'
					},
					{
						value: '宁夏',
						label: '宁夏'
					},
					{
						value: '新疆',
						label: '新疆'
					},
					{
						value: '内蒙',
						label: '内蒙'
					},
					{
						value: '澳门',
						label: '澳门'
					},
					{
						value: '香港',
						label: '香港'
					},
					{
						value: '台湾',
						label: '台湾'
					}
				],
				bidMethodOptions: [{
						"item": "院内",
						"value": "院内"
					},
					{
						"item": "第三方",
						"value": "第三方"
					},
					{
						"item": "其他",
						"value": "其他"
					},
				],
				bar_chart_area: {},
				bar_chart_user: {},
				//标准条形图设置
				bar_chart_record: {
					title: {
						text: '填报数量统计（按地区）',
						left: 'center',
						top: 20
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
					},
					toolbox: {
						show: true,
						orient: 'horizontal',
						left: 'right',
						top: 'left',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						bottom: 10,
						left: 'center',
						orient: 'horizontal',
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					},
					yAxis: [{
						type: 'value',
					}],
					xAxis: [{
						type: 'category',
						data: ['上海', '江苏', '北京', '浙江', '河南', '河北'],
						axisLabel: {
							interval: 0, // ★ 强制显示所有标签
							rotate: 45, // ★ 旋转，防止重叠（0 / 30 / 45 都行）
						}
					}],
					series: [{
							name: '填报数量',
							type: 'bar',
							emphasis: {
								focus: 'series'
							},
							data: [200, 444, 666, 123, 321, 555]
						},

					]
				},
			};
		},
		methods: {
			formatDate(val) {
				if (!val) return ''
				return val.split('.')[0].replace('T', ' ')
			},

			splitList(val) {
				if (!val) return []
				return String(val).split(',').filter(Boolean)
			},

			//通用函数-获取数据
			getData() {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				for (let key in that.searchData) {
					fd.append(key, that.searchData[key]);
				}
				fd.append('currentpage', that.currentPage);
				fd.append('pagesize', that.pageSize);

				this.$axios({
						url: '/apim/query/tender/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(response) {
						if (response.data.code == '401') {
							that.logout();
						} else {
							that.tableData = response.data.data;
							that.totalItems = response.data.totalItemNum;
							that.loading = false;
							that.bar_chart_area.title.text = "填报数据统计-按地区"
							that.bar_chart_area.xAxis[0].data = response.data.bar_chart_area_xAxis_0_data;
							that.bar_chart_area.series[0].data = response.data.bar_chart_area_series_0_data;

							that.bar_chart_user.title.text = "填报数据统计-按用户"
							that.bar_chart_user.xAxis[0].data = response.data.bar_chart_user_xAxis_0_data;
							that.bar_chart_user.series[0].data = response.data.bar_chart_user_series_0_data
						}
					})
					.catch(function(error) {
						console.log(error);
						that.loading = false;
					});
			},
			//重置搜索表单
			resetSearchForm(formName) {
				let that = this;
				this.$refs[formName].resetFields();
				this.$refs[formName].clearValidate();
				this.getData();
			},
			//通用功能 - 关键字搜索
			Search() {
				this.getData();
			},

			//分页跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData();
			},
			//每页显示条数更改
			handleSizeChange(val) {
				this.pageSize = val;
				this.getData();
			},
			// 获取品类列表
			getProdTypeOptions() {
				let that = this;
				this.$axios
					.get('/apim/retrieve/product_category/')
					.then(function(response) {
						that.prodTypeOptions = response.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//提交搜索
			submitFormSearchData() {
				this.getData();
			},
			//导出医院招投标数据
			exportData(queryData, filename) {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				let fileName = filename + Date.now();
				this.$axios({
						url: '/apim/export/tender/',
						responseType: 'blob',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						const _res = res.data;
						let blob = new Blob([_res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
						});
						let objectUrl = window.URL.createObjectURL(blob);
						let a = document.createElement('a');
						a.href = objectUrl;
						a.download = fileName.replace('.', '');
						a.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						}));
						that.loading = false;
						window.URL.revokeObjectURL(blob);
					})
					.catch(function(err) {
						that.loading = false;
						console.log(err);
					});
			}
		},
		mounted() {
			let that = this;
			this.getData();
		},
		created() {
			this.bar_chart_area = JSON.parse(JSON.stringify(this.bar_chart_record));
			this.bar_chart_user = JSON.parse(JSON.stringify(this.bar_chart_record));
		}
	};
</script>

<style scoped>
	.plate-card {
		width: 100%;
		height: 420px;
		padding: 10px;
		box-sizing: border-box;
	}

	.echarts {
		width: 100%;
		height: 100%;
	}

	.expand-wrapper {
		padding: 12px;
		background: #f5f7fa;
	}

	.card {
		margin-bottom: 10px;
		border-radius: 8px;
	}

	.el-table .cell {
		white-space: nowrap;
	}
</style>